import SettingsSidebar from './SettingsSidebar';

export default SettingsSidebar;
